export enum StripeEnv {
  RAISE = 'RAISE',
  SPONSOR = 'SPONSOR',
}

export enum Consumer {
  RAISE = 'RAISE',
  SPONSOR = 'SPONSOR',
  CONSUMER = 'CONSUMER',
  INSIGHTS = 'INSIGHTS',
}
